import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";
import { Modal } from "./kit";

const FORMATS = [
  Html5QrcodeSupportedFormats.QR_CODE,
  Html5QrcodeSupportedFormats.EAN_13,
  Html5QrcodeSupportedFormats.EAN_8,
  Html5QrcodeSupportedFormats.UPC_A,
  Html5QrcodeSupportedFormats.UPC_E,
  Html5QrcodeSupportedFormats.CODE_128,
  Html5QrcodeSupportedFormats.CODE_39,
  Html5QrcodeSupportedFormats.CODE_93,
  Html5QrcodeSupportedFormats.ITF,
  Html5QrcodeSupportedFormats.CODABAR,
];

export default function BarcodeScanner({ open, onClose, onScan }: { open: boolean; onClose: () => void; onScan: (code: string) => void }) {
  const [err, setErr] = useState("");
  const ref = useRef<Html5Qrcode | null>(null);

  useEffect(() => {
    if (!open) return;
    setErr("");
    let stopped = false;
    const t = setTimeout(() => {
      const sc = new Html5Qrcode("re-barcode-reader", { formatsToSupport: FORMATS, verbose: false });
      ref.current = sc;
      sc.start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 260, height: 160 }, aspectRatio: 1.4 },
        (text) => {
          if (stopped) return;
          stopped = true;
          sc.stop().catch(() => null).finally(() => onScan(text));
        },
        () => null
      ).catch(() => setErr("ক্যামেরা চালু করা যায়নি। ব্রাউজারে ক্যামেরা অনুমতি দিন।"));
    }, 150);
    return () => {
      clearTimeout(t);
      stopped = true;
      const sc = ref.current;
      if (sc && sc.isScanning) sc.stop().catch(() => null);
    };
  }, [open, onScan]);

  return (
    <Modal open={open} onClose={onClose} title="ক্যামেরা দিয়ে বারকোড স্ক্যান" testid="barcode-camera-modal">
      <div id="re-barcode-reader" className="w-full min-h-[240px] rounded-xl overflow-hidden bg-slate-900" />
      {err && <p className="mt-3 text-sm text-red-600" data-testid="barcode-camera-error">{err}</p>}
      <p className="mt-3 text-sm text-slate-500">পণ্যের বারকোড/QR ফ্রেমের মাঝে ধরুন — পেলে স্বয়ংক্রিয়ভাবে মেমোতে যোগ হবে।</p>
    </Modal>
  );
}
